export const SetConfirmationModal = (params) => {
  return {
    type: "SET_CONFIRMATION_MODAL",
    confirmationParams: params,
  };
};
export default SetConfirmationModal;
